export default __webpack_public_path__ + "static/media/Metropolis-Regular.1c132eba.woff";